$(function() {

    $.president = {};

    // durations

    $.president.duration = '100%';

    $.president.calculatePinDuration = function() {
        var contentHeight = $('#president-container .content-container').outerHeight();
        $.president.pinDuration = Math.round(contentHeight + ($(window).innerHeight() / 2));
        return $.president.pinDuration;
	};

    $.president.endDuration = '150%';

    // timelines

    $.president.tl = {};

    // in

	$.president.tl.in = new TimelineMax();

    $.president.tl.in.addLabel("start");
    $.president.tl.in.addLabel("content", 2);

    $.president.tl.in.set("#president-container", { visibility: "visible" }, "start");﻿

    if ($.chrome || $.firefox) { // chrome or firefox
        $.president.tl.in.set("#president-svg .circle", { svgOrigin: "1280 0" });
        $.president.tl.in.set("#president-svg .svg-text", { svgOrigin: "1280 0" });
    } else { // other browsers
        $.president.tl.in.set("#president-svg .circle", { transformOrigin: "50% 50%" });
        $.president.tl.in.set("#president-svg .svg-text", { svgOrigin: "1280 3200" }, "start");
    } // end other browsers

    $.president.tl.in.set("#president-background", { backgroundColor:$.color.black }, "start");
    $.president.tl.in.fromTo("#president-background", 1, { opacity:0 }, { opacity:1 }, "start");

    $.president.tl.in.fromTo("#president-svg .circle", 1, { scale:0 }, { scale:1, delay:1, force3D:true }, "start");

    $.president.tl.in.fromTo("#president-svg .svg-text", 1, { scale:0.5 }, { scale:1, delay:1, force3D:true }, "start");
    $.president.tl.in.fromTo("#president-svg .circle", 1, { scale:0 }, { scale:1, delay:1, force3D:true }, "start");

    $.president.tl.in.fromTo("#president-svg .svg-text", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");

    $.president.tl.in.fromTo("#president-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");

    $.president.tl.in.to("#president-svg .circle", 1, { scale:4.5, delay:0.5 }, "content");
    $.president.tl.in.to("#president-svg .svg-text", 1, { opacity: 0, delay:0.5 }, "content");

    if ($.windowWidth < $.breakpoint.lg) {
        $.president.tl.in.to("#president-svg .svg-text", 1, { y: "-960", delay:0.5 }, "content");
    } else if ($.windowWidth < $.breakpoint.e1) {
        $.president.tl.in.to("#president-svg .svg-text", 1, { y: "-480", delay:0.5 }, "content");
    } else {
        $.president.tl.in.to("#president-svg .svg-text", 1, { y: "-240", delay:0.5 }, "content");
    }

    $.president.tl.in.fromTo("#president-container .svg-content-overlay", 1, { opacity:0 }, { opacity:1, delay:1 }, "content");
    $.president.tl.in.fromTo("#president-container .content-container", 1, { opacity:0 }, { opacity:1, delay:1 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#president-pin', triggerHook: 'onLeave', duration: $.president.duration })
    	.setTween($.president.tl.in)
    	// .addIndicators({name: 'president in'})
    	.addTo($.controller);

    new ScrollMagic.Scene({ triggerElement: '#president-pin', triggerHook: 'onLeave', duration: $.president.calculatePinDuration })
        .setPin('#president-container .svg-background')
        // .addIndicators({name: 'president pin'})
        .addTo($.controller);

    $.president.tl.out = new TimelineMax();

    $.president.tl.out.addLabel("start");

    $.president.tl.out.to("#president-container .content-container", 1, { opacity:0 }, "start");
    $.president.tl.out.to("#president-background", 1, { opacity:0 }, "start");

    new ScrollMagic.Scene({ triggerElement: '#president-end', triggerHook: 'onCenter', duration: $.president.duration })
        .setTween($.president.tl.out)
        // .addIndicators({name: 'president out'})
        .addTo($.controller);

});
